function scrollDown() {
  const goDown = document.querySelector('#goDown')
  const belowFold = document.querySelector('#belowFold')

  if (goDown) {
    goDown.addEventListener('click', () => {
      belowFold.scrollIntoView({behavior: 'smooth', block: 'start'})
    })
  }
}

export default scrollDown
